/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_ProviderInputs */

const zh_analytics_provider = /** @type {(inputs: Analytics_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提供商`)
};

const en_analytics_provider = /** @type {(inputs: Analytics_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provider`)
};

const es_analytics_provider = /** @type {(inputs: Analytics_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proveedor`)
};

/**
* | output |
* | --- |
* | "Provider" |
*
* @param {Analytics_ProviderInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const analytics_provider = /** @type {((inputs?: Analytics_ProviderInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_ProviderInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_analytics_provider(inputs)
	if (locale === "en") return en_analytics_provider(inputs)
	return es_analytics_provider(inputs)
});